if (!customElements.get('ugc-video-slider')) {
  class UgcVideoSlider extends HTMLElement {
    connectedCallback() {
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.cards = Array.from(this.querySelectorAll('.ugc-video-slider__card.has-video'));
      this.videos = Array.from(this.querySelectorAll('video'));

      this.onVisibilityChange = this.onVisibilityChange.bind(this);
      this.onBlockSelect = this.onBlockSelect.bind(this);
      this.onBlockDeselect = this.onBlockDeselect.bind(this);

      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;

        video.muted = true;
        card.classList.add('is-muted');
        if (video.paused) card.classList.add('is-paused');

        video.addEventListener('play', () => card.classList.remove('is-paused'));
        video.addEventListener('pause', () => card.classList.add('is-paused'));

        card.addEventListener('click', (event) => {
          if (event.target.closest('[data-ugc-mute], a')) return;
          this.togglePlayback(video);
        });

        const muteButton = card.querySelector('[data-ugc-mute]');
        if (muteButton) {
          muteButton.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.toggleMute(card, video);
          });
        }
      });

      this.sectionObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.playAll();
            } else {
              this.pauseAll();
            }
          });
        },
        { threshold: 0.15 }
      );
      this.sectionObserver.observe(this);

      if (!this.reduceMotion) this.playAll();

      document.addEventListener('visibilitychange', this.onVisibilityChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    disconnectedCallback() {
      if (this.sectionObserver) this.sectionObserver.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
      document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
    }

    togglePlayback(video) {
      if (video.paused) {
        this.playVideo(video);
      } else {
        video.pause();
      }
    }

    toggleMute(card, video) {
      const shouldUnmute = video.muted;

      this.videos.forEach((otherVideo) => {
        otherVideo.muted = true;
      });
      this.cards.forEach((otherCard) => {
        otherCard.classList.add('is-muted');
        this.syncMuteLabel(otherCard, true);
      });

      video.muted = !shouldUnmute;
      card.classList.toggle('is-muted', video.muted);
      this.syncMuteLabel(card, video.muted);

      if (shouldUnmute && video.paused) this.playVideo(video);
    }

    syncMuteLabel(card, muted) {
      const muteButton = card.querySelector('[data-ugc-mute]');
      if (!muteButton) return;
      const label = muted ? muteButton.dataset.labelUnmute : muteButton.dataset.labelMute;
      muteButton.setAttribute('aria-label', label);
      muteButton.setAttribute('aria-pressed', muted ? 'true' : 'false');
    }

    playVideo(video) {
      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {});
      }
    }

    playAll() {
      if (this.reduceMotion) return;
      this.videos.forEach((video) => this.playVideo(video));
    }

    pauseAll() {
      this.videos.forEach((video) => video.pause());
    }

    onVisibilityChange() {
      if (document.hidden) {
        this.pauseAll();
        this.classList.add('is-marquee-paused');
      } else {
        this.classList.remove('is-marquee-paused');
        this.playAll();
      }
    }

    onBlockSelect(event) {
      const slide = event.target.closest('.ugc-video-slider__slide');
      if (!slide || !this.contains(slide)) return;
      this.classList.add('is-marquee-paused');
    }

    onBlockDeselect(event) {
      const slide = event.target.closest('.ugc-video-slider__slide');
      if (!slide || !this.contains(slide)) return;
      this.classList.remove('is-marquee-paused');
    }
  }

  customElements.define('ugc-video-slider', UgcVideoSlider);
}
